// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".info[data-v-2211d392]{word-break:break-all;width:100%}.info[data-v-2211d392] img{width:100%;height:auto}.activity-container[data-v-2211d392]{width:100%;word-break:break-all}.activity-container .submit[data-v-2211d392]{position:fixed;bottom:3.2vw;left:50%;transform:translateX(-50%);border:none;background:linear-gradient(137.7deg,#f90,#ff6a3a);color:#fff;margin:3.2vw auto;width:75.733vw}", ""]);
// Exports
module.exports = exports;
